// DEPRECATED: stop using
export enum Channels {
  EMAIL = 'EMAIL',
  INAPP_WEB = 'INAPP_WEB',
  PUSH = 'PUSH',
  WEB_PUSH = 'WEB_PUSH',
  SMS = 'SMS',
  CALL = 'CALL'
}

export enum ActiveChannels {
  EMAIL = 'EMAIL',
  INAPP_WEB = 'INAPP_WEB',
  WEB_PUSH = 'WEB_PUSH',
  PUSH = 'PUSH',
  SMS = 'SMS',
  CALL = 'CALL'
}
